import utils from './utils.js';
import { cloneDeep } from 'lodash';
import { funnelUtilsConstants as utilsConstants } from '@puls/puls-common-constants';
import AppStorage from './appstorage.js';

export default {
    getPricesRequestObject: (appState, options = {}) => {
        const appointmentState = utils.getAppointmentState(appState)
        let { selectedService, selectedServicesCart } = appointmentState;
        if(!selectedService && (!selectedServicesCart || !selectedServicesCart.length)) return null;
        let ingredients = utils.getCustomerDevicesIngridiants(appointmentState);

        if(appState.coupon && appState.coupon.promoCodeValidationData.isValid && ingredients[0]){
            ingredients[0].promocodes = [appState.coupon.promoCode]
        }

        let addressData = utils.getAddressDataComponents(cloneDeep(appState));
        let zipcode = addressData.postal_code || appState.zipcode.zipcode || ''
        let funnelId = utils.acuireFunnelId(appointmentState);
        let calculateParams = {
            marketId : appState.zipcode.marketId,
            funnelId,
            type: 'withTaxes',
            ingredients,
            zipcode
        }

        if(appState.userdetails.plan.id){
            calculateParams.subscription_plan_id = appState.userdetails.plan.id;
        }

        //inject benefits
        try {
            if(!options.withoutBenefitServices){
                appState.userdetails.plan.benefits.filter(a => a.selected).forEach((benefit) => {
                    calculateParams.ingredients[0].services.push({serviceId: benefit.service_id})
                })
            }
        } catch (e) {

        }


        if(appState.config.creating_in_admin || appState.config.context === 'blender') {
            if(!calculateParams.extraDetails) calculateParams.extraDetails = {};
            calculateParams.extraDetails.skip_ab_test = 1;
        } else {
            if(funnelId) {
                var groupMappingId = AppStorage.ServerContextObject.get(appState.zipcode.marketId, funnelId);
                if(groupMappingId) calculateParams[utilsConstants.SERVER_AB_TEST_GROUP_ID] = groupMappingId;
            }
        }

        return calculateParams;
    },
    getSalePricesRequestObject: (appState) => {
        let {selected_sale_id, current_sale_type, payment_type} = appState.sales;
        const addressData = utils.getAddressDataComponents(appState);
        const zipcode = addressData.postal_code || appState.zipcode.zipcode || (appState.address.googleData.googleMarketId === 20 ? '888' : '');
        if(!selected_sale_id || !zipcode || !current_sale_type) return null;
        const serviceToSend = appState.sales.salesListMap[current_sale_type][selected_sale_id];
        const isYearlyPayment = utils.isYearlypaymentType(appState.sales.payment_type);
       
        var calculateParams = {
            marketId : appState.zipcode.marketId || addressData.googleMarketId,
            funnelId: 0,
            type: 'withTaxes',
            ingredients: [
                {
                    deviceId: 0,
                    services: [
                        { serviceId: isYearlyPayment ? serviceToSend.service_id : serviceToSend.service_id_monthly },
                    ]
                }
            ],
            zipcode
        }
        try {
            const discountPrice = utils.getDiscountSalePrice(appState);
            if(discountPrice) {
                calculateParams.ingredients[0].services.push({ serviceId: 1077, price: discountPrice, payment: discountPrice})
            }
        } catch (error) {
            
        }

        if(appState.sales.custom_amount && utils.isYearlypaymentType(payment_type)){
            const price = utils.calculateCustomerCredit(appState)
            if(price) {
                calculateParams.ingredients[0].services.push({ serviceId: price > 0 ? 1666 : 1077, price: Math.abs(price), payment: Math.abs(price)})
            }
        }

        if(utils.isAuxSaleFlow(appState.config.flow)) {
            appState.sales.planAddons.forEach((addon) => {
                if(addon.selected) calculateParams.ingredients[0].services.push({serviceId: isYearlyPayment ? addon.withService : addon.withServiceMonthly})
            })
        }
        
        calculateParams.subscription_plan_id = appState.sales.salesListMap[current_sale_type][selected_sale_id].plan_id;
        return calculateParams
    },
    buildAddonsPriceListMap: (addons) => {
        const addonsPrices = addons.reduce((acc, addon) => {
            acc[addon.service_id] = {
                totalPrice: addon.price,
                monthlyPrice: addon.price_monthly,
                serviceDisplayTitle: addon.title
            }
            return acc;
        }, {})

        return addonsPrices;
    }
}
